import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IContractorHireHistoryInput } from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export abstract class ContractorHireHistoryApiService {
  abstract update(contractorHireHistory: IContractorHireHistoryInput): Observable<any>;
}
